import React from 'react';
import { convertKeysToCamelCase } from '../../../../helpers/baseHelpers';
import style from '../../../../assets/scss/components/settings-page/SettingsCard.module.scss';

export const SettingsCardContainer: React.FC = ({ children }) => {
  const { settingsCardsContainer } = convertKeysToCamelCase(style);
  return <div className={settingsCardsContainer}>{children}</div>;
};
